import { LucideBuilding2, LucideKey, LucideUser } from '@lucide/angular';
import { Branding } from "./branding.model";

export const BRANDING: Branding = {

    logo: 'assets/images/arabela-logo.png',
    title: 'Sistema Administración de Promociones e Incentivos',
    title2: 'de Incentivos',
    subtitle: 'Plataforma corporativa para administrar campañas, incentivos y productividad.',
    footer: 'Arabela © 2026. Todos los derechos reservados.',

    features: [

        {

            icon: LucideBuilding2,
            title: 'Gestión Centralizada',
            description: 'Administra campañas e incentivos.'

        },
        {

            icon: LucideUser,
            title: 'Seguimiento en tiempo real',
            description: 'Consulta indicadores en tiempo real.'

        },
        {
            icon: LucideKey,
            title: 'Seguridad avanzada',
            description: 'Autenticación empresarial.'
        }
    ]

};